import JustValidate from 'just-validate';
import { apiErrorsDictionary } from '../constants/formErrorMessages';

const SCREEN_SUCCESS_CLASS = 'form-success';

export default class BaseFormModel {
    #form;
    #screen;
    #submitButton;
    #formSelector;
    #errorMessageEl;
    #validator;
    #submitHandler;
    #validationScheme = {};

    get form() {
        return this.#form;
    }

    init(formSelector, params) {
        this.#formSelector = formSelector;
        this.#validationScheme = params.validationScheme;
        this.#submitHandler = params.onSubmit;
        this.#form = document.querySelector(this.#formSelector);
        this.#submitButton = this.#form.querySelector('button[type="submit"]');
        this.#errorMessageEl = this.#form.querySelector('.js-form-error-message');
        this.#screen = this.#form.closest('.screen');

        this.#form.reset();
        // this.disableSubmit();
        this.initValidation();

        // this.showFormSuccess();
    }

    initValidation() {
        this.#validator = new JustValidate(this.#formSelector, {
            errorFieldCssClass: ['invalid']
        });

        Object.entries(this.#validationScheme).forEach(([name, rules]) => {
            const fieldEl = this.#form.querySelector(`[name="${name}"]`);

            this.#validator.addField(fieldEl, rules);
        });

        this.#validator.onSuccess(async () => {
            this.hideFormError();

            if (!this.#submitHandler) return;

            this.showLoading();

            const { error } = await this.#submitHandler();

            this.hideLoading();

            if (error) {
                this.showFormError(error);
            }
        });

        // this.#validator.onValidate(({ isValid }) => {
        //     if (isValid) {
        //         this.enableSubmit();
        //     } else {
        //         this.disableSubmit();
        //     }
        // });
    }

    showLoading() {
        this.#submitButton.classList.add('loading');
    }

    hideLoading() {
        this.#submitButton.classList.remove('loading');
    }

    showFormSuccess() {
        if (!this.#screen) return;

        this.#screen.classList.add(SCREEN_SUCCESS_CLASS);
    }

    showFormError(error) {
        if (!this.#errorMessageEl) return;

        const {
            status, text, validationErrors, messageToShow
        } = error;

        if (messageToShow) {
            this.#errorMessageEl.innerHTML = messageToShow;

            return;
        }

        let errorMessage = '';

        if (validationErrors) {
            Object.values(validationErrors).forEach((errorsArray) => {
                errorsArray.forEach((eText) => {
                    const errorText = apiErrorsDictionary[eText] || '';

                    if (errorText) {
                        errorMessage = `${errorText}. ${errorMessage}`;
                    }

                });
            });

            this.#errorMessageEl.innerHTML = errorMessage;

            return;
        }

        switch (status) {
            case 401:
                errorMessage = 'Ошибка. Проверьте правильность введённых данных.';

                break;
            case 422:
                errorMessage = text || 'Ошибка. Проверьте правильность введённых данных.';

                break;
            default:
                errorMessage = 'Ошибка. Попробуйте обновить страницу.';
        }

        this.#errorMessageEl.innerHTML = errorMessage;
    }

    hideFormError() {
        this.#errorMessageEl.innerHTML = '';
    }

    resetFull() {
        this.resetForm();
        this.resetScreen();
    }

    resetForm() {
        this.#form.reset();
        this.#validator.refresh();
        this.hideFormError();
    }

    resetScreen() {
        if (!this.#screen) return;

        this.#screen.classList.remove(SCREEN_SUCCESS_CLASS);
    }

    enableSubmit() {
        this.#submitButton.removeAttribute('disabled');
    }

    disableSubmit() {
        this.#submitButton.setAttribute('disabled', true);
    }
}
